<template>
  <v-autocomplete
    hide-details="auto"
    :items="warehouses"
    :loading="loading"
    v-model="filterDatas.warehouse"
    item-text="name"
    item-value="id"
    label="Warehouse"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.warehouse)"
    :search-input.sync="searchWarehouses"
  ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    warehouses: [],
    selectedWarehouse: null,
    searchWarehouses: null,
    loading: false,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_WAREHOUSE_FILTER', data);
      this.$emit('input', this.filterDatas.warehouse);
    },
    getWarehouseByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('warehouse/GetWarehouse', {
          query: this.filterDatas.warehousequery
            ? this.filterDatas.warehousequery
            : query,
          status: 'active',
        })
        .then((res) => {
          this.loading = false;
          this.warehouses = res;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedWarehouse = null;
      },
      deep: true,
    },
    searchWarehouses: {
      handler(val) {
        this.$store.commit('UPDATE_WAREHOUSE_AUTOCOMPLETE_QUERY_FILTER', val);
        this.getWarehouseByQuery(val);
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.warehouse);

    this.getWarehouseByQuery();
  },
};
</script>
